





import {Vue, Component, Emit, Prop} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";

@Component({})
export default class ServisneOperacijeEditor extends Vue {
    @Prop() value!: string;
    @Prop() data!: [];
    servisneOperacije = [];

    loader = async (params, success, failure) => {
        success(await dataProxy.vratiServisneOperacijePoNazivu(params.data.term));
    };

    processResults(data: any[]) {
        this.servisneOperacije = data;
        return {
            results: data.map((x) => ({id: x.naziv, text: x.naziv}))
        }
    }

    @Emit('input') changed(value) {
        const servisnaOperacija = this.servisneOperacije.find(x => x.naziv == value);
        this.grupaDelova(servisnaOperacija ? [servisnaOperacija.grupaDelovaVozilaId].filter(x => x != null) : []);
        this.vrstaOdrzavanja(servisnaOperacija ? servisnaOperacija.vrstaOdrzavanjaId : null);
    }

    @Emit() grupaDelova(value) {
    }

    @Emit('vrsta-odrzavanja-changed') vrstaOdrzavanja(value) {
    }
}
